export const searchResultValue = [{
  index: '0', value: '精准高效：搜索能快速找到符合我需求的内容',
}, {
  index: '1', value: '闲逛发现：搜索能发现没想到的服务和业务',
}, {
  index: '2', value: '以上都不是（请说明）',
}];

export const searchResultGood = [{
  index: '0', value: '搜索结果与关键词匹配',
}, {
  index: '1', value: '搜索结果丰富多彩',
}, {
  index: '2', value: '搜索能帮我发现新优惠或服务',
}, {
  index: '3', value: '其他',
}];

export const searchResultBad = [{
  index: '0', value: '搜索结果与关键词不匹配',
}, {
  index: '1', value: '搜索结果与关键词匹配，但内容不喜欢',
}, {
  index: '2', value: '搜索结果不够丰富多样',
}, {
  index: '3', value: '搜索没能帮我发现新优惠或服务',
}, {
  index: '4', value: '其他',
}];

export const duaringSearchGood = [{
  index: '0', value: '推荐词符合我的诉求',
}, {
  index: '1', value: '发现了新鲜想看的东西',
}, {
  index: '2', value: '推荐词丰富，方便看起来',
}, {
  index: '3', value: '其他',
}];

export const duaringSearchBad = [{
  index: '0', value: '推荐词不感兴趣',
}, {
  index: '1', value: '重复推荐',
}, {
  index: '2', value: '实际搜索结果和这个词没关系',
}, {
  index: '3', value: '其他',
}];

export const searchSugGood = [{
  index: '0', value: '联想出我记不住的词',
}, {
  index: '1', value: '与搜索意图相关，方便快捷',
}, {
  index: '2', value: '联想词丰富，帮我发现新内容',
}, {
  index: '3', value: '其他',
}];

export const searchSugBad = [{
  index: '0', value: '都快写完了才猜中我想搜什么',
}, {
  index: '1', value: '与搜索意图无关',
}, {
  index: '2', value: '没出联想词',
}, {
  index: '3', value: '错别字等表述错误',
}, {
  index: '4', value: '其他',
}];
